module.exports = require("github:jspm/nodelibs-buffer@0.1.1/index");